module.exports = __webpack_public_path__ + "static/media/sd.16a2cbb1.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/flags/sd.svg
// module id = 241
// module chunks = 0